import { motion } from "framer-motion";
import { PieChart, Users, GraduationCap, ArrowRight } from "lucide-react";
import { Reveal } from "../Reveal";
import { Logo } from "../Logo";
import { useLang } from "../../i18n/LanguageContext";

const icons = [PieChart, Users, GraduationCap];

export const Differentiation = () => {
  const { t } = useLang();
  return (
    <section data-testid="differentiation-section" className="bg-sinovar-soft py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="rounded-[2rem] border border-black/[0.05] bg-white px-6 py-12 md:px-14 md:py-16">
          <Logo />
          <Reveal>
            <h2 className="mt-10 font-display text-4xl md:text-[3.2rem] font-bold tracking-tight text-sinovar-navy leading-[1.05]">
              {t.diff.title}
              <br />
              <span className="text-sinovar-red">{t.diff.titleAccent}</span>
            </h2>
          </Reveal>
          <div className="mt-5 h-0.5 w-10 rounded-full bg-sinovar-red" />

          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
            {t.diff.items.map((item, i) => {
              const Icon = icons[i];
              return (
                <motion.div
                  key={i}
                  data-testid={`diff-card-${i}`}
                  initial={{ opacity: 0, y: 26 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.6, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
                  className="group flex flex-col items-center rounded-2xl border border-black/[0.06] bg-white px-8 py-10 text-center hover:shadow-xl hover:shadow-sinovar-navy/5 transition-shadow"
                >
                  <div className="flex h-16 w-16 items-center justify-center rounded-full bg-sinovar-soft text-sinovar-blue">
                    <Icon className="h-7 w-7" strokeWidth={1.6} />
                  </div>
                  <h3 className="mt-6 font-display text-xl font-bold tracking-tight text-sinovar-navy">{item.name}</h3>
                  <div className="mt-4 h-0.5 w-8 rounded-full bg-sinovar-red" />
                  <p className="mt-4 text-[15px] text-sinovar-navy/55 leading-relaxed">{item.desc}</p>
                  <div className="mt-7 flex h-9 w-9 items-center justify-center rounded-full bg-sinovar-soft text-sinovar-blue transition-colors group-hover:bg-sinovar-blue group-hover:text-white">
                    <ArrowRight className="h-4 w-4" />
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
